export default "__VITE_ASSET__CqZVsbzJ__"